import { render, staticRenderFns } from "./TracksReleasesReadOnlyPanel.vue?vue&type=template&id=82c3ac68"
import script from "./TracksReleasesReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./TracksReleasesReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./TracksReleasesReadOnlyPanel.vue?vue&type=style&index=0&id=82c3ac68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports